declare global {
  interface Window {
    VIA_RUNTIME_CONFIG?: Record<string, string>;
  }
}

/*
 * These are environment variables that are read at build time,
 * not during runtime.
 */
/* const getFromBuildEnv = (params: {
  envvar?: string;
  defaultValue: string;
}): string => {
  const envValue = params.envvar ?? "";

  if (envValue === "") {
    return params.defaultValue;
  }
  return envValue;
}; */

const getFromRuntimeEnv = (params: {
  envvar: string;
  defaultValue: string;
}): string => {
  const runtimeConfig: Record<string, string> = window.VIA_RUNTIME_CONFIG ?? {};

  const value = runtimeConfig[params.envvar];
  return value !== undefined && value !== null && value !== ""
    ? value
    : params.defaultValue;
};

/*
 * The config contains both runtime set and buildtime set values.
 * For local to work, all runtime values should have good defaults.
 *
 */
const Config = {
  // Locally we don't have a prefix
  ROUTER_BASENAME: getFromRuntimeEnv({
    envvar: "basename",
    defaultValue: "",
  }),
  HOST: getFromRuntimeEnv({
    envvar: "host",
    defaultValue: "http://localhost:8081",
  }),
  DOCS_URL: getFromRuntimeEnv({
    envvar: "docs_url",
    defaultValue: "/docs",
  }),
};

/*
 * Build an absolute docs URL from the runtime-configured docs base.
 * When DOCS_URL is a path (default "/docs") it is served from this host;
 * when it is a full URL it is used as is. `subPath` is an optional
 * sub-path (with a leading slash) appended to the base.
 */
export const getDocsUrl = (subPath = ""): string => {
  const base = Config.DOCS_URL.startsWith("/")
    ? `${Config.HOST}${Config.DOCS_URL}`
    : Config.DOCS_URL;
  return `${base}${subPath}`;
};

// --- Exports -----------------------------------

export default Config;
